import { render, staticRenderFns } from "./TemplateImport.vue?vue&type=template&id=20d16150&scoped=true&"
import script from "./TemplateImport.vue?vue&type=script&lang=js&"
export * from "./TemplateImport.vue?vue&type=script&lang=js&"
import style0 from "./TemplateImport.vue?vue&type=style&index=0&id=20d16150&prod&scoped=true&lang=css&"
import style1 from "./TemplateImport.vue?vue&type=style&index=1&id=20d16150&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d16150",
  null
  
)

export default component.exports